import React from 'react'
import './laptop.styles.css'
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Navbar from '../Navbar';
import laptopCentralHeating from './laptopPages/laptop-centralHeating';
import laptopDomesticHotWater from './laptopPages/laptop-domesticHotWater';
import laptopPoolHeating from './laptopPages/laptop-poolHeating';
import laptopProjects from './laptopPages/laptop-projects';
import laptopSolarWaterHeating from './laptopPages/laptop-solarWaterHeating';
import laptopHome from './laptopPages/laptop-home';
import LandingPage from '../LandingPage';

export const Laptop = () => {
    return (
            <>
      <Router >
        <div className="laptop">
        <Navbar />
        <Switch >
        <Route path='/' exact component={laptopHome} />
        <Route path='/landing' component={LandingPage} />
          <Route path='/central-heating' component={laptopCentralHeating} />
          <Route path='/domesticHotWater' component={laptopDomesticHotWater} />
          <Route path='/pool-heating' component={laptopPoolHeating} />
          <Route path='/solar-waterHeating' component={laptopSolarWaterHeating} />
          <Route path='/projects' component={laptopProjects} />
        </Switch>
        </div>
        </Router>
    </>
    )
}